import { createContext, FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'
import { Add as AddIcon } from '@mui/icons-material'
import { Button } from '@mui/material'
import { ConfigListPageShell } from '@mobileComponents/ConfigListPageShell'

import { StyleSettingsDialog } from '@components/StyleSettingsDialog'

import { AllStyleSettings } from '@pages/ConfigStyleSettings/components/AllStyleSettings/AllStyleSettings'
import { useConfigStyleSettings } from '@pages/ConfigStyleSettings/hooks/useConfigStyleSettings'
import { PageContextType } from '@pages/ConfigStyleSettings/types/types'

export const PageContext = createContext<PageContextType>({} as PageContextType)

export const ConfigStyleSettings: FC = () => {
  const { t } = useTranslation()

  const {
    state: { allStyleSettings, currentSort },
    data: {
      isAllStyleSettings,
      methods,
      isLoadingStyleSettingsData,
      styleSettingsDialogOpen,
      editingStyleSettingId,
    },
    handlers: {
      handleCreateStyleSetting,
      handleEditStyleSetting,
      handleDeleteStyleSetting,
      handleCloseStyleSettingsDialog,
      handleSetSorting,
    },
  } = useConfigStyleSettings()

  const contextValue = {
    allStyleSettings,
    isLoadingStyleSettingsData,
    currentSort,
    onCreateStyleSetting: handleCreateStyleSetting,
    onEditStyleSetting: handleEditStyleSetting,
    onDeleteStyleSetting: handleDeleteStyleSetting,
    onSetSorting: handleSetSorting,
  }

  return (
    <PageContext.Provider value={contextValue}>
      <Outlet />
      <StyleSettingsDialog
        isShow={!!styleSettingsDialogOpen}
        styleSettingId={editingStyleSettingId ?? undefined}
        onClose={handleCloseStyleSettingsDialog}
      />
      <ConfigListPageShell
        title={t('pageTitle.styleSettings')}
        isVisible={!!isAllStyleSettings}
        actions={
          <Button variant='contained' startIcon={<AddIcon />} onClick={handleCreateStyleSetting}>
            Create
          </Button>
        }
      >
        <AllStyleSettings methods={methods} />
      </ConfigListPageShell>
    </PageContext.Provider>
  )
}

